<template>
  <div class="box-father">
    <div style="height: 100%" v-show="!qusetionDetailDialog">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">统计分析管理&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>上报问题统计分析</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="大小循环">
                  <el-select
                    filterable
                    placeholder="请选择大小循环"
                    clearable
                    v-model="form.handleRoleLevelInList"
                  >
                    <el-option
                      v-for="item in handleRoleLevelInListOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="任务状态">
                  <el-select
                    filterable
                    placeholder="请选择任务状态"
                    clearable
                    v-model="form.handleState"
                  >
                    <el-option
                      v-for="item in openFlagOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="数据来源">
                  <el-select
                    filterable
                    placeholder="请选择数据来源"
                    clearable
                    multiple
                    v-model="form.reportSourceList"
                  >
                    <el-option
                      v-for="item in reportSourceListOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="案件号">
                  <el-input
                    v-model="form.caseNumber"
                    clearable
                    placeholder="请输入案件号搜索"
                  ></el-input>
                </el-form-item>
                <el-form-item label="指标">
                  <el-input
                    v-model="form.eventIndexName"
                    clearable
                    placeholder="请输入指标"
                  ></el-input>
                </el-form-item>
                <el-form-item label="处置节点">
                  <el-select
                    filterable
                    placeholder="请选择处置节点"
                    clearable
                    v-model="form.handleRoleLevel"
                  >
                    <el-option
                      v-for="item in handleRoleLevelOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="事项名称">
                  <el-input
                    v-model="form.eventName"
                    clearable
                    placeholder="请输入事项名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="点位">
                  <el-input
                    v-model="form.pointName"
                    clearable
                    placeholder="请输入社区或网格名称搜索"
                  ></el-input>
                </el-form-item>
                <el-form-item label="上报时间">
                  <el-date-picker
                    v-model="form.valueTime"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 400px !important"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="上报人员">
                  <el-input
                    v-model="form.reportUserName"
                    clearable
                    placeholder="请输入上报人员"
                  ></el-input>
                </el-form-item>
                <el-form-item label="上报部门">
                  <el-input
                    v-model="form.reportDeptName"
                    clearable
                    placeholder="请输入上报部门"
                  ></el-input>
                </el-form-item>

                <!-- <el-form-item label="问题描述">
                <el-input
                  v-model="form.typeName"
                  clearable
                  placeholder="请输入问题描述"
                ></el-input>
              </el-form-item> -->

                <el-form-item label="处置部门">
                  <el-select
                    style="width: 356px"
                    v-model="form.handleDeptId"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in deptList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <!-- <el-input
                    v-model="form.masterDeptName"
                    clearable
                    placeholder="请输入办理部门"
                  ></el-input> -->
                </el-form-item>
                <el-form-item label="小循环截止时间">
                  <el-date-picker
                    v-model="form.sqDueTime"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 400px !important"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="大循环截止时间">
                  <el-date-picker
                    v-model="form.ksDueTime"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 400px !important"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="table-top-btns">
            <div class="left-btn"></div>
            <div class="right-btn">
              <el-button
                @click="exportAllDetail(1)"
                icon="el-icon-download"
                class="search"
                >统计数导出</el-button
              >
              <el-button
                @click="exportDetail({})"
                icon="el-icon-download"
                class="search"
                >导出</el-button
              >
              <el-button
                @click="exportAllDetail(2)"
                icon="el-icon-download"
                class="search"
                >导出统计</el-button
              >
              <el-button
                v-if="btns && btns.includes('batch')"
                @click="openBatchHandleDialog"
                class="search"
                >批量结案</el-button
              >
            </div>
          </div>
          <common-table
            :select="btns && btns.includes('batch')"
            :page="page"
            :dataList="dataList"
            :selectedIdOptions="selectedIdOptions"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            @handleSelectionChange="handleSelectionChange"
            @selectAll="selectAll"
            :maxHeight="640"
          >
            <template v-slot:enableStatus="{ scope }">
              <el-switch
                @change="
                  value => {
                    updatePointTypeFun(value, scope.row);
                  }
                "
                v-model="scope.row.enableStatus"
                :active-value="0"
                :inactive-value="1"
                active-color="#0495FF"
              >
              </el-switch>
            </template>
            <template v-slot:taskFileJson="{ scope }">
              <div
                v-for="(item, index) in scope.row.taskFileJson"
                :key="index"
                style="margin-right: 4px; cursor: pointer; color: #0090ff"
                @click="openNew(scope.row.taskFileJson)"
              >
                {{ item.url }}
              </div>
            </template>
            <template v-slot:handleFileJson="{ scope }">
              <div
                v-for="(item, index) in scope.row.handleFileJson"
                :key="index"
                style="margin-right: 4px; cursor: pointer; color: #0090ff"
                @click="openNew(scope.row.handleFileJson)"
              >
                {{ item.url }}
              </div>
            </template>
            <template v-slot:reportSource="{ scope }">
              <div class="flex-center">
                <span v-if="scope.row.reportSource == 'wg'">网格上报</span>
                <span v-if="scope.row.reportSource == 'jm'"
                  >居民上报未转网格</span
                >
                <span v-if="scope.row.reportSource == 'jmToWg'"
                  >居民转网格</span
                >
                <span v-if="scope.row.reportSource == 'qy'">企业上报</span>
              </div>
            </template>
            <template v-slot:handleRoleLevel="{ scope }">
              <div class="flex-center">
                <span v-if="scope.row.handleRoleLevel == 'R1'">网格员</span>
                <span v-if="scope.row.handleRoleLevel == 'R2'">社区书记</span>
                <span v-if="scope.row.handleRoleLevel == 'R3'">包片科室</span>
                <span v-if="scope.row.handleRoleLevel == 'R4'">职能部门</span>
              </div>
            </template>
            <template v-slot:handleRoleLevelInList="{ scope }">
              <div class="flex-center">
                <span
                  v-if="
                    scope.row.handleRoleLevel == 'R1' ||
                      scope.row.handleRoleLevel == 'R2' ||
                      scope.row.handleRoleLevel == 'R3'
                  "
                  >小循环</span
                >
                <span v-if="scope.row.handleRoleLevel == 'R4'">大循环</span>
              </div>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="qusetionDetail(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >问题详情</el-button
              >
              <el-button
                @click="openBm(scope.row)"
                v-if="
                  scope.row.transitionState202501 == '未处置' &&
                    scope.row.handleRoleLevel == 'R4' &&
                    strGLLD == 1
                "
                style="color: #0090ff; font-size: 16px"
                type="text"
                >更换部门</el-button
              >
              <el-button
                v-if="btns.length && btns.includes('changeWg')"
                @click="openWg(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >更换网格</el-button
              >
              <el-button
                @click="deleteDialogFun(scope.row)"
                :class="['tuihui']"
                type="text"
                v-if="strGLLD == 1"
                >删除</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <detail
      v-if="qusetionDetailDialog"
      @closeDetail="qusetionDetailDialog = false"
      :pointInfo="pointInfo"
      title1="上报问题统计分析"
      title2="问题详情"
    ></detail>
    <addDialog
      v-if="dialogVisible"
      @refreshList="getPointTypeListPageFun"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
    >
    </addDialog>
    <pictureDialog
      v-if="dialogPictureVisible"
      :dialogVisible.sync="dialogPictureVisible"
      :pictureList="pictureList"
    >
    </pictureDialog>
    <exportDialog
      v-if="dialogExportVisible"
      :dialogVisible.sync="dialogExportVisible"
      :typeExport="typeExport"
    >
    </exportDialog>
    <!-- 导出选择列弹出 -->
    <exportSelectionColumn
      v-if="dialogExportSelectionColumnVisible"
      :dialogVisible.sync="dialogExportSelectionColumnVisible"
      :form="form"
    >
    </exportSelectionColumn>
    <!-- 批量结案 -->
    <batchHandleDialog
      v-if="batchHandleVisible"
      @refreshList="getPointTypeListPageFun"
      :dialogVisible.sync="batchHandleVisible"
      :selectedIdOptions="selectedIdOptions"
    >
    </batchHandleDialog>
    <!-- 批量结案 -->
    <changeWg
      v-if="wgHandleVisible && deptList.length"
      @refreshList="getPointTypeListPageFun"
      :dialogVisible.sync="wgHandleVisible"
      :deptList="deptList"
      :curItem="wgCurItem"
    >
    </changeWg>
    <changeWgg
      v-if="wgHandleVisibleWg"
      @refreshList="getPointTypeListPageFun"
      :dialogVisible.sync="wgHandleVisibleWg"
      :curItem="wgCurItemWg"
    >
    </changeWgg>
  </div>
</template>
<script>
import {
  getPointTypeListPage,
  updatePointType,
  delPointType
} from "@/api/point.js";
import {
  reportTaskLeftHandlePage,
  reportfullDetail,
  reportTaskLeftHandleExp,
  reportTaskLeftHandleTotalExp,
  taskLeftHandleImgExp,
  taskIndexFullDel
} from "@/api/task.js";
import { downloadFile, getDeptTree } from "@/api/systemManagement.js";
import addDialog from "./components/addDialog.vue";
import batchHandleDialog from "./components/batchHandleDialog.vue";
import pictureDialog from "./components/pictureDialog.vue";
import exportDialog from "./components/exportDialog.vue";
import commonTable from "@/components/table/index2.vue";
import pageChangeSelect from "./page-change-select.js";
import detail from "./components/detail.vue";
import changeWg from "./components/changeWg.vue";
import exportSelectionColumn from "./components/exportSelectionColumn.vue";
import { taskChooseExportFeildList } from "../../api/task";
import changeWgg from "./components/changeWgg.vue";
export default {
  components: {
    addDialog,
    commonTable,
    detail,
    pictureDialog,
    exportDialog,
    exportSelectionColumn,
    batchHandleDialog,
    changeWg,
    changeWgg
  },
  mixins: [pageChangeSelect],
  data() {
    return {
      form: {
        eventName: "",
        handleState: "",
        handleDeptId: "",
        reportTimeStart: "",
        reportTimeEnd: "",
        pointName: "",
        reportUserName: "",
        reportDeptName: "",
        handleRoleLevel: "",
        eventIndexName: "",
        handleRoleLevelInList: [],
        caseNumber: "",
        reportSourceList: [],
        valueTime: [],
        sqDueTime: [],
        ksDueTime: []
      },
      reportSourceListOptions: [
        {
          label: "网格上报",
          value: "wg"
        },
        {
          label: "居民上报未转网格",
          value: "jm"
        },
        {
          label: "居民转网格",
          value: "jmToWg"
        },
        {
          label: "企业上报",
          value: "qy"
        }
      ],
      openFlagOptions: [
        // {
        //   label: "待分拨",
        //   value: "待分拨",
        // },
        // {
        //   label: "待认领",
        //   value: "待认领",
        // },
        {
          label: "未处置",
          value: "未处置"
        },
        {
          label: "已处置",
          value: "已处置"
        }
        // {
        //   label: "已办结",
        //   value: "已办结",
        // },
      ],
      handleRoleLevelOptions: [
        {
          label: "网格员",
          value: "R1"
        },
        {
          label: "社区书记",
          value: "R2"
        },
        {
          label: "包片科室",
          value: "R3"
        },
        {
          label: "职能部门",
          value: "R4"
        }
      ],
      handleRoleLevelInListOptions: [
        {
          label: "大循环",
          value: ["R4"]
        },
        {
          label: "小循环",
          value: ["R1", "R2", "R3"]
        }
      ],
      dialogVisible: false,
      wgHandleVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            slot: "handleRoleLevelInList",
            label: "大小循环",
            width: 100
          },
          {
            prop: "transitionState202501",
            label: "任务状态",
            width: 90
          },
          {
            slot: "reportSource",
            label: "数据来源",
            width: 140
          },
          {
            prop: "caseNumber",
            label: "案件号",
            width: 150
          },
          {
            prop: "eventIndexName",
            label: "指标",
            width: 180
          },
          {
            slot: "handleRoleLevel",
            label: "处置节点",
            width: 100
          },
          {
            prop: "taskDetail",
            label: "问题描述",
            width: 120
          },

          {
            prop: "eventName",
            label: "事项名称",
            width: 120
          },

          {
            prop: "communityName",
            label: "社区",
            width: 120
          },
          {
            prop: "blockName",
            label: "网格",
            width: 120
          },
          {
            prop: "reportTime",
            label: "上报时间",
            width: 180
          },
          {
            prop: "reportUserName",
            label: "上报人员",
            width: 120
          },
          {
            prop: "reportDeptName",
            label: "上报部门",
            width: 120
          },

          {
            prop: "reportDb",
            label: "大办",
            width: 90
          },
          {
            prop: "fbTime",
            label: "AI确认时间",
            width: 180
          },
          {
            prop: "sqDueTime",
            label: "小循环截止时间",
            width: 180
          },
          {
            prop: "ksDueTime",
            label: "大循环截止时间",
            width: 180
          },
          {
            slot: "taskFileJson",
            label: "上报照片",
            width: 135,
            showToolitip: false
          },

          {
            slot: "handleFileJson",
            label: "处置照片",
            width: 135,
            showToolitip: false
          },
          {
            prop: "handleUserName",
            label: "处置人员",
            width: 90
          },
          {
            prop: "handleDeptName",
            label: "处置部门",
            width: 120
          },
          {
            prop: "handleTime",
            label: "处置时间",
            width: 180
          },
          {
            slot: "operation",
            label: "操作",
            width: 300,
            fixed: "right"
          }
        ]
      },
      curItem: {},
      wgCurItem: {},
      qusetionDetailDialog: false,
      pointInfo: {},
      curTabIndex: 0,

      deptList: [],
      dialogPictureVisible: false,
      pictureList: [],
      dialogExportVisible: false,
      exportOneLoading: false,
      exportTwoLoading: false,
      typeExport: "",
      strGLLD: "",
      batchHandleVisible: false,
      dialogExportSelectionColumnVisible: false,
      btns: [],
      wgCurItemWg: {},
      wgHandleVisibleWg: false,
      roles: {}
    };
  },
  mounted() {
    this.roles = sessionStorage.getItem("userInfo") ? JSON.parse(sessionStorage.getItem("userInfo")).roles.map(item => item.roleCode) : [];
    this.strGLLD = sessionStorage.getItem("strGLLD");
    let menuChildren = JSON.parse(sessionStorage.getItem("menuChildren"));
    menuChildren.forEach(element => {
      if (element.data.menuCode == "StatisticalAnalysisManage") {
        element.children.forEach(item => {
          if (item.data.menuCode == "ReportproblemAnalysis") {
            if (item.children && item.children.length) {
              this.btns = item.children.map(itm => itm.data.menuCode) || [];
            }
          }
        });
      }
    });
    console.log(this.btns, "this.btns");

    this.getTree();
    this.getPointTypeListPageFun();
  },
  methods: {
    openWg(item) {
      this.wgCurItemWg = item;
      this.wgHandleVisibleWg = true;
    },

    openBm(item) {
      this.wgCurItem = item;
      this.wgHandleVisible = true;
    },

    openBatchHandleDialog() {
      if (!this.selectedIdOptions.length) {
        this.$message({
          type: "error",
          message: "请先选择上报问题"
        });
        return;
      }
      this.batchHandleVisible = true;
    },
    qusetionDetail(item) {
      this.pointInfo = item;

      this.qusetionDetailDialog = true;
    },
    // 获取部门资源树形
    async getTree() {
      let params = {
        page: 999,
        size: 1,
        pid: "2000000035",
        data: true
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptList = res.data.data;
      }
    },
    addDialogFun(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    deleteDialogFun(item) {
      this.$confirm("您确认要删除该条数据吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await taskIndexFullDel({
            id: item.taskId
          });
          if (res.data.code == 200) {
            this.$message.success("删除成功");
            this.getPointTypeListPageFun();
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.selectedIdOptions = [];
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.selectedIdOptions = [];
      this.form.eventName = "";
      this.form.handleState = "";
      this.form.handleDeptId = "";
      this.form.pointName = "";
      this.form.caseNumber = "";
      this.form.eventIndexName = "";
      this.form.reportDeptName = "";
      this.form.reportUserName = "";
      this.form.reportTimeStart = "";
      this.form.reportTimeEnd = "";
      this.form.handleRoleLevel = "";
      this.form.valueTime = [];
      this.form.sqDueTime = [];
      this.form.ksDueTime = [];
      this.form.handleRoleLevelInList = [];
      this.form.reportSourceList = [];
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    // 开启关闭
    async updatePointTypeFun(value, item) {
      let params = {
        enableStatus: value,
        typeName: item.typeName,
        id: item.id
      };
      const res = await updatePointType(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.getPointTypeListPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 删除
    async delPointTypeFun(delList, flag) {
      let params = {
        delList: delList
      };
      const res = await delPointType(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        if (flag) this.selectedIdOptions = [];
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 模板下载
    async downloadFileFun() {
      const res = await downloadFile({
        filePath: "/templates/部门事项导入模板.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "部门事项导入模板.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },
    // 数据导入
    async importDataFun(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await importData(formData);
      if (res.data.code == 200) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.onSearch();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        eventName: this.form.eventName,
        transitionState202501: this.form.handleState,
        handleDeptId: this.form.handleDeptId,
        pointName: this.form.pointName,
        caseNumber: this.form.caseNumber,
        eventIndexName: this.form.eventIndexName,
        reportUserName: this.form.reportUserName,
        reportDeptName: this.form.reportDeptName,
        handleRoleLevel: this.form.handleRoleLevel,
        reportTimeStart: this.form.valueTime && this.form.valueTime[0],
        reportTimeEnd: this.form.valueTime && this.form.valueTime[1],
        sqDueTimeStart: this.form.sqDueTime && this.form.sqDueTime[0],
        sqDueTimeEnd: this.form.sqDueTime && this.form.sqDueTime[1],
        ksDueTimeStart: this.form.ksDueTime && this.form.ksDueTime[0],
        ksDueTimeEnd: this.form.ksDueTime && this.form.ksDueTime[1],
        handleRoleLevelInList: this.form.handleRoleLevelInList || [],
        reportSourceList: this.form.reportSourceList || [],
        page: this.page.page,
        size: this.page.size
      };
      const res = await reportTaskLeftHandlePage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.dataList.tableData.forEach(item => {
          item.taskFileJson = !item.taskFileJson
            ? []
            : JSON.parse(item.taskFileJson);
          item.taskFileJsonZip = !item.taskFileJsonZip
            ? []
            : JSON.parse(item.taskFileJsonZip);
          item.handleFileJson = !item.handleFileJson
            ? []
            : JSON.parse(item.handleFileJson);
        });
        this.page.total = res.data.data.total;
      }
    },

    async exportDetail() {
      this.dialogExportSelectionColumnVisible = true;
      // let res = await reportTaskLeftHandleExp({
      //   eventName: this.form.eventName,
      //   transitionState202501: this.form.handleState,
      //   handleDeptId: this.form.handleDeptId,
      //   pointName: this.form.pointName,
      //   caseNumber: this.form.caseNumber,
      //   reportUserName: this.form.reportUserName,
      //   reportDeptName: this.form.reportDeptName,
      //   reportTimeStart: this.form.valueTime && this.form.valueTime[0],
      //   reportTimeEnd: this.form.valueTime && this.form.valueTime[1],
      //   page: this.page.page,
      //   size: this.page.size,});
      //   if (res.status == 200) {
      //   this.dialogExportSelectionColumnVisible = false;
      //   const url = window.URL.createObjectURL(new Blob([res.data]));
      //   const link = document.createElement("a");
      //   link.href = url;
      //   // link.setAttribute(
      //   //   "download",
      //   //   "问题列表导出加图片展示" + new Date().getTime() + ".txt"
      //   // );
      //   document.body.appendChild(link);
      //   link.click();
      // }
    },
    async exportImgDetail() {
      this.exportTwoLoading = true;
      let res = await taskLeftHandleImgExp({
        eventName: this.form.eventName,
        transitionState202501: this.form.handleState,
        handleDeptId: this.form.handleDeptId,
        pointName: this.form.pointName,
        caseNumber: this.form.caseNumber,
        eventIndexName: this.form.eventIndexName,
        reportUserName: this.form.reportUserName,
        reportDeptName: this.form.reportDeptName,
        handleRoleLevel: this.form.handleRoleLevel,
        reportTimeStart: this.form.valueTime && this.form.valueTime[0],
        reportTimeEnd: this.form.valueTime && this.form.valueTime[1],
        sqDueTimeStart: this.form.sqDueTime && this.form.sqDueTime[0],
        sqDueTimeEnd: this.form.sqDueTime && this.form.sqDueTime[1],
        ksDueTimeStart: this.form.ksDueTime && this.form.ksDueTime[0],
        ksDueTimeEnd: this.form.ksDueTime && this.form.ksDueTime[1],
        handleRoleLevelInList: this.form.handleRoleLevelInList || [],
        reportSourceList: this.form.reportSourceList || []
      });

      if (res.status == 200) {
        this.exportTwoLoading = false;
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "待完善事项" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      }
    },
    async exportAllDetail(type) {
      this.typeExport = type;
      this.dialogExportVisible = true;
    },
    openNew(list) {
      this.dialogPictureVisible = true;
      this.pictureList = list.map(i => i.url);
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/reportproblemAnalysis/index.vue